import { isArray } from 'util';
import { parseNumber } from '../../utils/number.utils';
import { Validation } from '../validation';
import { ActivityTimeBuilder } from './activity-time.builder';

export class ValidationBuilder {
  static fromJson(json) {
    return (json)
      ? new Validation(
        json.hash,
        json.modelHash,
        json.modelName,
        json.modelImagePath,
        json.brandImage,
        json.brandBWImage,
        parseNumber(json.modelOrder),
        parseNumber(json.validationDay),
        json.validated,
        json.hasIncompleteData,
        json.shortDay,
        ActivityTimeBuilder.fromList(json.activitiesTime),
        parseNumber(json.totalTime),
        json.modelReference
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(ValidationBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/validation.builder.ts